export enum GtmEventAction {
  ContactUsLanding = 'contactus_landing',
  ContactUsAcLanding = 'contactus_ac_landing',
  ContactUsStarted = 'contact_us_started',
  contactUsSubmitted = 'contact_us_submitted',
}
